import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api/client'
import { ROUTES } from '../routes'
import AuthCard, { authCardStyles as s } from './AuthCard'
import Button from './Button'
import ConsentCheckbox from './ConsentCheckbox'
import { CONSENT_GATE_HINT, CONSENT_GATE_TITLE, translateAuthError } from '../authMessages'

// Экран согласия вместо хаба: показывается при любом открытии приложения,
// пока согласия на текущий документ нет, — сразу после входа и у тех, кто
// вошёл раньше и не выходил. Сервер при этом отклоняет остальные запросы,
// так что экран лишь показывает состояние, а не охраняет его.
export default function ConsentGate ({ user, onAccepted, onLogout }) {
  const navigate = useNavigate()
  const [accepted, setAccepted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function handleSubmit (e) {
    e.preventDefault()
    if (!accepted || loading) return
    setError(null)
    setLoading(true)
    try {
      const result = await api.acceptConsent()
      // Согласие приходит новой сессией: прежняя выдана до согласия и API её
      // не пропускает.
      localStorage.setItem('ch_token', result.token)
      onAccepted(result.user)
    } catch (err) {
      setError(translateAuthError(err))
    } finally {
      setLoading(false)
    }
  }

  // Явный выход — не истёкшая сессия: точку возврата не запоминаем, иначе
  // следующий аккаунт после входа попал бы на страницу предыдущего.
  function handleLogout () {
    localStorage.removeItem('ch_token')
    navigate(ROUTES.LOGIN, { replace: true })
    onLogout()
  }

  return (
    <AuthCard>
      <form onSubmit={handleSubmit} style={s.form}>
        <div style={s.stepTitle}>{CONSENT_GATE_TITLE}</div>
        <div style={s.hint}>{CONSENT_GATE_HINT}</div>

        <ConsentCheckbox checked={accepted} onChange={setAccepted} />

        {error && <div style={s.error} role='alert'>{error}</div>}

        <Button
          type='submit'
          variant='solid'
          disabled={!accepted}
          loading={loading}
          style={{ width: '100%', marginTop: 4 }}
        >
          Продолжить
        </Button>

        <div style={s.who}>
          Вы вошли как {user.email}
          {' · '}
          <button style={{ ...s.link, alignSelf: 'auto', fontSize: 12 }} type='button' onClick={handleLogout}>
            Выйти
          </button>
        </div>
      </form>
    </AuthCard>
  )
}
